<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content mx-auto max-w-md px-5">
                <div class="bg-white w-full rounded-40 py-5 px-4">
                    <template v-if="hasTitle">
                        <div class="mb-7 text-semi text-15 text-a-gray-666666 text-center" v-text="title"></div>
                    </template>
                    <div class="text-normal text-15 text-a-gray-666666 text-center" v-html="message"></div>
                    <div class="flex flex-col w-full m-auto mt-9">
                        <button type="button"
                            class="w-full bg-a-gray-333333 text-white text-15 text-semi rounded-full outline-none appearance-none mb-4 h-16 capitalize"
                            @click="clickOk()">
                            {{ btnOk }}
                        </button>
                        <button type="button"
                            class="w-full text-a-gray-333333 text-15 text-normal outline-none appearance-none h-45px capitalize"
                            @click="clickCancel()">
                            {{ btnCancel }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Utility from '@/helper/Utility';
import { inject } from 'vue';

export default {
    name: "ConfirmModal",
    props: {
        controller: Object,
    },
    data: function () {
        return {
            open: false,

            message: '',
            title: '',
            btnOk: '',
            btnCalcel: '',
            busModal: null,
        };
    },
    computed: {
        hasTitle: function () {
            return !Utility.isEmptyStr(this.title)
        }
    },
    setup: function () {
        const { lbl } = inject("LocaleStore")
        return {
            lbl
        }
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function () {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function (config) {
            this.title = config.title
            this.message = config.msg
            this.btnOk = config?.btnOk ?? this.lbl.base_button.confirm
            this.btnCancel = config?.btnCancel ?? this.lbl.base_button.cancel

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/module/TheOne/style/base.scss";
@import "@/style/modal.scss";

.modal {
    @extend %modal;

    .modal-content {
        width: 100%;
    }
}
</style>
